import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiFileText, FiSettings, FiClock } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import axios from 'axios';
import QuoteStepper from './QuoteStepper';
import ProposalHistory from './ProposalHistory';
import SubscriptionGate from './SubscriptionGate';
import QuoteProposalSettings from './QuoteProposalSettings';
import { useToast } from '../../context/ToastContext';
import '../../styles/QuoteProposal.css';
const getAmsToken = () => localStorage.getItem('amsToken') || '';
type ActiveView = 'proposal' | 'history' | 'settings';
const QuoteProposalPage: React.FC = () => {
    const { '*': wildcardPath } = useParams();
    const navigate = useNavigate();
    const [activeView, setActiveView] = useState<ActiveView>('proposal');
    const [stepperKey, setStepperKey] = useState(0);
    useEffect(() => {
        if (wildcardPath?.trim())
            setActiveView('proposal');
    }, [wildcardPath]);
    const [tokenReady, setTokenReady] = useState(false);
    const { showError } = useToast();
    useEffect(() => {
        const initToken = async () => {
            try {
                const amsToken = getAmsToken();
                const res = await axios.get(`${(process.env.REACT_APP_Auth_Url || '')}/api/account/toolboxtoken`, {
                    params: { nctoken: amsToken },
                });
                const token = res.data?.token;
                if (token)
                    localStorage.setItem('toolboxToken', token);
            }
            catch {
                showError('Failed to initialize session.');
            }
            finally {
                setTokenReady(true);
            }
        };
        initToken();
    }, []);
    if (!tokenReady) {
        return (<div className="qp-page">
        <div className="qp-init-loader">
          <div className="qp-init-loader__orb">
            <div className="qp-init-loader__ring qp-init-loader__ring--1"/>
            <div className="qp-init-loader__ring qp-init-loader__ring--2"/>
            <div className="qp-init-loader__ring qp-init-loader__ring--3"/>
            <div className="qp-init-loader__core">
              <FiFileText size={22}/>
            </div>
          </div>
          <div className="qp-init-loader__text">
            <p className="qp-init-loader__title">Quote Proposal</p>
            <p className="qp-init-loader__sub">
              Initializing session
              <span className="qp-init-loader__dots">
                <span>.</span><span>.</span><span>.</span>
              </span>
            </p>
          </div>
          <div className="qp-init-loader__bar">
            <div className="qp-init-loader__bar-shimmer"/>
          </div>
        </div>
      </div>);
    }
    return (<div className="qp-page" style={{ position: 'relative' }}>
      
      {activeView === 'settings' && (<div style={{ position: 'absolute', inset: 0, zIndex: 20, background: 'var(--bg-primary, #0c0c0f)', overflowY: 'auto' }}>
          <QuoteProposalSettings onBack={() => {
                setStepperKey(k => k + 1);
                navigate(ROUTES.QUOTE_PROPOSAL, { replace: true });
                setActiveView('proposal');
            }}/>
        </div>)}

      
      {activeView === 'history' && (<div style={{ position: 'absolute', inset: 0, zIndex: 20, background: 'var(--bg-primary, #0c0c0f)', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
          <div className="qp-page-chrome">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button className="qp-header__back" onClick={() => {
                setStepperKey(k => k + 1);
                navigate(ROUTES.QUOTE_PROPOSAL, { replace: true });
                setActiveView('proposal');
            }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
                  </svg>
                  Back
                </button>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button className="qp-header__back" onClick={() => setActiveView('settings')}>
                  <FiSettings size={14}/>
                  Settings
                </button>
              </div>
            </div>
          </div>
          <div className="qp-page-scroll" style={{ flex: 1 }}>
            <ProposalHistory onContinueDraft={() => {
                navigate(ROUTES.QUOTE_PROPOSAL, { replace: true });
                setStepperKey(k => k + 1);
                setActiveView('proposal');
            }} onCreateNew={() => {
                setStepperKey(k => k + 1);
                navigate(ROUTES.QUOTE_PROPOSAL, { replace: true });
                setActiveView('proposal');
            }}/>
          </div>
        </div>)}

      
      {activeView === 'proposal' && (<div className="qp-page-chrome">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button className="qp-header__back" onClick={() => setActiveView('history')}>
                <FiClock size={14}/>
                History
              </button>
              <button className="qp-header__back" onClick={() => setActiveView('settings')}>
                <FiSettings size={14}/>
                Settings
              </button>
            </div>
          </div>
        </div>)}

      
      <SubscriptionGate>
        <QuoteStepper key={stepperKey}/>
      </SubscriptionGate>

      
    </div>);
};
export default QuoteProposalPage;
